/**
 * @generated SignedSource<<22e2e2d5ab527ff7b9de1cde8253b18f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignTiles_designPageInfo$data = {
  readonly creatorDesigns: ReadonlyArray<{
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbRespDesignTiles_designPageInfo";
};
export type SbRespDesignTiles_designPageInfo$key = {
  readonly " $data"?: SbRespDesignTiles_designPageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignTiles_designPageInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespDesignTiles_designPageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesign",
      "kind": "LinkedField",
      "name": "creatorDesigns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DesignPageInfo",
  "abstractKey": null
};

(node as any).hash = "35b98c562a65c482026a7f66ff16b69d";

export default node;
